export const localStorageKeys = {
    tokenKey: "DO_AUTH_TOKEN" as const,

}